/**
 * contextSwitcher — Helper para limpar qualquer resíduo legado da
 * preferência de painel (WL × Tenant) gravada em `localStorage` por
 * versões anteriores.
 *
 * O login sempre apresenta `/select-context` quando há cruzamento
 * WL × tenant; a troca dentro da sessão é feita pelo switcher do
 * header. Não persistimos mais a escolha — esta função existe apenas
 * para "garbage collection" do valor antigo (`wl-last-context`).
 *
 * CHANGELOG:
 *   v1.1.0 — 2026-05-29 — Remove set/get; mantém apenas clear como GC do
 *            valor legado.
 *   v1.0.0 — 2026-05-29 — Implementação inicial.
 */

const STORAGE_KEY = 'wl-last-context';

/** Remove a preferência legada caso ainda exista. */
export function clearLastContextChoice(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore (modo privado / storage cheio)
  }
}
